<template>
   <div>
      <v-layout wrap pt-5>
         <v-flex xs12>
         <span class="myheader" v-if="curriculum && curriculum.type ==='CoachUp'">
            Coaching Curriculum: {{curriculum ? curriculum.name : ''}}

         </span>
         <span class="myheader" v-else>
            Sales Person Performance: {{curriculum ? curriculum.name : ''}}
         </span>

            <div class="hr"/>

         </v-flex>

         <v-flex xs12 sm12 md12 v-if="curriculum">

            <template v-for="(value, i) in curriculum.questions">
               <v-layout :key="i" justify-center wrap>

                  <v-flex xs6 align-self-center class="myquestion">
                     Q{{ i + 1 }}: {{ curriculum.questions[i].q_id.question }}
                  </v-flex>

                  <v-flex xs6 v-if="curriculum.questions[i].q_id.answers.length<6">
                     <v-radio-group
                         v-model="form.answers[i]"
                         v-on:change="grade_form(i)"
                         :rules="[x=> checkRadioGroup(x)]"
                         :readonly="disable_ans(value.q_id)"
                         row
                     >
                        <v-radio
                            v-for="(value2, j) in curriculum.questions[i].q_id.answers"
                            :key="j"
                            :label="curriculum.questions[i].q_id.answers[j].ans"
                            :value="j"
                            height="100px"
                        ></v-radio>
                     </v-radio-group>
                  </v-flex>

                  <v-flex xs6 v-else>
                     <v-flex xs6>
                        <v-autocomplete
                            :items="curriculum.questions[i].q_id.answers"
                            item-value="ix"
                            item-text="ans"
                            v-model="form.answers[i]"
                            v-on:change="grade_form(i)"
                            :rules="[x => isRequired(x, 'Answer')]"
                            :readonly="disable_ans(value.q_id)"
                        ></v-autocomplete>
                     </v-flex>
                     <v-flex xs6></v-flex>
                  </v-flex>


                  <v-flex md12>

                     <div class="hr"/>
                  </v-flex>

               </v-layout>
            </template>
         </v-flex>

         <v-flex v-else class="error--text" style="font-size: x-large;">
            There was an issue getting the user's curriculum
         </v-flex>

      </v-layout> <!--end of grading form-->
      <v-layout v-if="display_grade">
         <v-flex grow></v-flex>
         <v-flex shrink>
            Score: {{ round(grade_score0, 1) }} | Grade: {{ grade_letter0 ? grade_letter0 : 'N/A' }}
            <!--<v-btn @click="grade_form">See Grade</v-btn>-->
         </v-flex>
      </v-layout>
   </div>

</template>

<script>
import validate from "@/mixins/validation";
import curricula_common from "@/views/Curricula/curricula_common";
import data_getters from "@/mixins/data_getters";

export default {
   name: "formCurriculum",
   mixins: [validate, curricula_common, data_getters],
   props:{
      curriculum: Object,
      form: Object,
      grade_score: Number,
      grade_letter: String,

      display_grade: {type:Boolean, default: ()=> true}
   },
   data(){
      return {
         grade_score0: 0,
         grade_letter0: '',
      }
   },
   watch:{
      grade_score0(){
         this.$emit('update:grade_score', this.grade_score0);
         console.log('grade score update', this.grade_score0)
      },

      grade_letter0(){
         this.$emit('update:grade_letter', this.grade_letter0)
      }
   },

   methods:{
      //****************************************************************************************************************
      /**
       *
       * @param ix_this_q : index of the question that just changed
       */

      grade_form(ix_this_q){
         try{
            this.grade_form0(ix_this_q);
         }
         catch(e){
            this.edit_error_msg = `Cannot compute grade.  This is most likely due to the curriculum and/or question(s) being changed since this lead was originally graded.`;
         }
      },


      grade_form0(ix_this_q){
         if (!this.curriculum){
            return;
         }

         let questions = this.curriculum.questions;
         this.grade_score0 = 0;
         let max_score = 0;

         // compute max score including duplicates
         for (let i=0; i<questions.length; i++){
            max_score +=  questions[i].weight;
         }


         //compute answers for linked questions****************************
         for (let i=0; i<questions.length; i++){
            let lq = questions[i].q_id.linked_questions;
            // console.log(lq)

            if (lq !== null && i !== ix_this_q){
               let vals = [];

               //get question id's for input questions
               for (let j=0; j<lq.inputs.length; j++){
                  let ix = this.findWithAttr(questions, 'q_id._id', lq.inputs[j].q_id);
                  let ans_ix = this.form.answers[ix];

                  console.log('ix', ix, 'ans_ix', ans_ix);
                  if (ix !== -1 && ans_ix !== undefined){
                     let val = this.curriculum.questions[ix].q_id.answers[ans_ix].ans;
                     // val = val.split(' ')[0];
                     vals.push(val);
                  }else{
                     vals.push(null);
                  }
               }


               console.log('q', i+1, 'input vals', vals);

               //********get computed answer***********************************
               if (lq.link_type === 'FunctionOf'){

                  vals = vals.map(x => typeof x === 'string' ? x.split(' ')[0] : NaN); //needed in case the ans val is "10 or more"
                  let ans = this.func_list(lq.function)(...vals);
                  console.log('computed ans', ans)


                  //get the index of the answer for this question
                  // assumes answers[j].json is not null and has form {"range": [a, b], "txt": "..."}
                  for (let j=0; j<questions[i].q_id.answers.length; j++){
                     try{
                        let range = questions[i].q_id.answers[j].json.range;
                        if (ans > range[0] && ans <= range[1]){
                           this.form.answers[i.toString()] = j; // note, answers is an object, not an array
                           break;
                        }
                     }
                     catch(e){
                        console.error(e);
                     }
                  }
               }// if FunctionOf

               //********check if we need to exclude this question********
               else if (lq.link_type === 'ExcludeOn'){

                  let exclude_val = "Doesn't Apply";

                  //check if at least one input's answer is set
                  if ( vals.some(x => x !== exclude_val && typeof x === 'string')){
                     //then set this question's value to "Not Applicable"

                     //get index of "Not Applicable" answer for this question
                     let ans_ix = this.findWithAttr(questions[i].q_id.answers, 'ans', exclude_val);

                     if (ans_ix > -1 ){
                        this.form.answers[i] = ans_ix; //questions[i].q_id.answers[ans_ix].;
                        console.log(`setting answer =${i}, to value=${ans_ix}`)
                     }
                     else{
                        console.log(`Coudn't get index of "${exclude_val}" answer`)
                     }
                  }
               }// if ExcludeOn

               //********check if dependsOn********
               else if (lq.link_type === 'DependsOn'){

                  for (let j=0; j<vals.length; j++){

                     console.log('if_these', lq.inputs[j].if_these)
                     if (lq.inputs[j].if_these.includes(vals[j])){

                        let ans_ix = this.findWithAttr(questions[i].q_id.answers, 'ans', lq.inputs[j].ans_to_set);
                        if (ans_ix > -1 ){
                           this.form.answers[i] = ans_ix; //questions[i].q_id.answers[ans_ix].;
                           console.log(`setting answer =${i}, to value=${ans_ix}`)
                        }
                        else{
                           console.log(`Coudn't get index of "${lq.inputs[j].ans_to_set}" answer`)
                        }
                     }
                  }

               }// if DependsOn

            }//if this is a linked question

         }//for questions

         // end of compute answers for linked questions****************************


         // compute score based on current answers
         let i=0;
         let weight;
         for (i=0; i<questions.length; i++){



            let ans_score = 0;
            let ans_ix = this.form.answers[i];

            weight = questions[i].weight;
            //check if the question has been answered and grabs score of the answer if it has
            if (ans_ix !== undefined){

               // console.log({i, ans_ix})

               // check if the answer is "Not applicable"
               let tmp = questions[i].q_id.answers[ans_ix].score;
               if (parseInt(tmp) === -1){
                  max_score -= weight;
                  ans_score = 0
               }
               else{
                  ans_score = questions[i].q_id.answers[ans_ix].score
               }
            }// if ans_id is defined


            this.grade_score0 += ans_score * weight;

            // console.log({i, ans_ix, ans_score, weight, question: questions[i]})
         }//for i

         this.grade_score0 = this.grade_score0/max_score*100;

         // this.grade_score = this.round(this.grade_score, 2);

         //get letter grade
         this.grade_letter0 = null;
         i=0;
         while (this.grade_letter0 === null){
            let low = this.curriculum.grading_scale[i].score_low;
            let high = this.curriculum.grading_scale[i].score_high;

            //deal with score being above 100 or below 0
            if (i===0) high += 100;
            if (i===this.curriculum.grading_scale.length-1) low -= 100;

            if (low < this.grade_score0 && this.grade_score0 <= high){
               this.grade_letter0 = this.curriculum.grading_scale[i].grade;
            }
            i++;
         }




         console.log('max_score', max_score)

      },
   }
}
</script>

<style scoped>
.myheader{
    font-size: large;
    font-weight: bold;
    color: grey;
}
</style>
